import React from 'react';
import MetamaskInstallChecker from "./MetamaskInstallChecker";
import MetamaskConnect from "./MetamaskConnect";

function MetamaskConnectButton(props) {
    return (
        <MetamaskInstallChecker functionComponent={() => <MetamaskConnect {...props}/>} {...props} />
    );
}

export default MetamaskConnectButton;
